import React, {Component} from 'react';
import {translate} from 'react-i18next';
import WaitingModal from '../../../generics/WaitingModal';
import swal from 'sweetalert';

import {Typeahead} from 'react-bootstrap-typeahead';

var Config = require('../../../../config');

class UnitSearch extends Component{
	constructor(props){
		super(props);

		this.onSearch = this.onSearch.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.getBloodComponent = this.getBloodComponent.bind(this);

		this.state = {
			unit_number   : "",
			unit_required : false,
			code_component: "",
			component_number:"",
			code_component_list:[],
			code_required : false,
			component_id:"",

			results:[],
			components:[],

			isLoading: false
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		this.getBloodComponent();
	}

	getBloodComponent(){
		fetch(Config.default.apiGateway.URL+'blood_component', {
			method : 'get',
			headers: new Headers({
				'Authorization' : 'Bearer ' + sessionStorage.getItem("token"),
				'Accept'	 	: 'application/json',
				'Content-Type' 	: 'application/json'
			})
		})
		.then(res => {
            if(res.ok){
              return res.json();
            }else{
              res.text().then(function(result) {
                swal('¡Error', result, 'error');
              });
            }})
		.then(response => {
			this.setState({
				components: response
			});
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	onSearch(e){
		if(e.length > 0){
			var valid = true;

			if(e[0].status_laboratory.indexOf('RECHAZADA') !== -1){
				valid = false;
			}else if(e[0].status_laboratory.indexOf('BLOQUEADA') !== -1){
				valid = false;
			}

			if(valid){
				var component = e[0].label.split(' ')[0];
				var number = e[0].label.split(' ')[1];
				this.setState({
		   			code_component: component,
		   			component_number: number,
		   			component_id: e[0].unit_id,
		   			isLoading: true,
		   		});
		   
			   	setTimeout(function(){
					fetch(Config.default.apiGateway.URL+'units/by_code?code='+this.state.code_component+'&unit_number='+this.state.unit_number+
						"&component_number="+this.state.component_number, {
						method : 'get',
						headers: new Headers({
							'Authorization'	: 'Bearer '+sessionStorage.getItem("token"),
							'Accept'		: 'application/json',
							'Content-Type'	: 'application/json'
						})
					})
					.then(res => {
						//document.getElementById('process_id').focus();

			            if(res.ok){
			              return res.json();
			            }else{
			              res.text().then(function(result) {
			                swal('¡Error', result, 'error');
			              });
			            }})
					.then(response => {
						if(response !== null){
							if(response.units.length > 0){
								this.props.sendData(response, this.state.component_id);							
							}else{
								swal('Unidad no encontrada', "", 'warning');
							}

							this.setState({
								code_required:false,
								unit_required:false,
								unit_number   : "",
								code_component: "",
								component_number:"",
								component_id:"",
								value:"",
								suggestions:[],
								code_component_list:[],
								isLoading:false
							});
						}

						this._typeahead.getInstance().clear();
						
					});
					
			   	}.bind(this), 500);
			}else{
				this._typeahead.getInstance().clear();
				this._typeahead.getInstance().focus();
				swal('No puede seleccionar el componente', e[0].status_laboratory, 'error');

			}
				
		}
	}

	validateInput(e) {
	    const re = /^[-+]?$/;

	    if (e.key === "Enter") {
      		e.preventDefault(); // Prevent form submission if button present
      		
      		const form = e.target.form;
      		const index = Array.prototype.indexOf.call(form, e.target);

      		if(form.elements[index + 1] !== undefined)
    			form.elements[index + 1].focus();
    	
		    if (!re.test(e.key)) {
		      e.preventDefault();
		    }
		}
  	}

	searchComponent(e){
		if(e.key === 'Enter'){
			e.preventDefault();

			this.validateInput(e);
			this.props.waiting.handleShow('Cargando...');

			fetch(Config.default.apiGateway.URL+'units/transformation_search?unit_number='+e.target.value+
				'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'), {
				method: 'get',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then(msg=>{
						swal("Error", msg, 'error')
					});

					document.getElementById('unit_number').focus();
				}
			})
			.then(response=>{
				if(response !== undefined){
					this.setState({
						code_component_list: response
					})
					
				}

			})

		}
	}

	render(){

		return (
			<div className="col-xs-12">
				<div className="col-xs-12 col-sm-3 col-md-2" >
					<span className="span-min">Número de Unidad</span>
					<input type="text" name="unit_number" id="unit_number" onKeyPress={(e) => this.props.validate(e)} 
						onChange={this.handleChange} value={this.state.unit_number || ""} 
						onKeyPress={(e) => this.searchComponent(e)}
						className={this.state.unit_required ? "form-control error" : "form-control"} />
				</div>

				<div className="col-xs-12 col-sm-3 col-md-2" >
					<span className="span-min">Código Componente</span>

					<Typeahead
			          	/*{...this.state}*/
			          	labelKey={(option) => `${option.label}`}
			          	minLength={0}
			          	options={this.state.code_component_list}
			          	onSearch={this.state.code_component_list}
			          	onChange={this.onSearch}
			            inputProps={{
			          		name:"code_component",
			          		id:"code_component"
			          	}}
			          	id="codeComponent"
			          	isLoading={this.state.isLoading}
			          	ref={ref => this._typeahead = ref}
			          	delay={600}
			          	paginationText="Mostrar mas resultados..."
			        />
				</div>

				<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(UnitSearch);